const PlaybookReportType = {
  MonthInReview: "month_in_review"
};
export {
  PlaybookReportType
};
//# sourceMappingURL=playbookReport.js.map
